export default {
  countryListPlusGlobal: (state:any) => {
    return [{code: '', id:0, name: 'Global'},...state.countryList]
  },
};